// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_k1-0";
export var discountCodeInput = "_k1-1";